import './style.scss'
import React from 'react'
import { FiBriefcase } from 'react-icons/fi'
import { BackLink, Text, Flex, Box, tokens } from 'src/componentv2'
import { fontBold } from 'src/model/v2/interface/constants'

export type ConfigurationTabKey =
    | 'profile' | 'branding' | 'business-logic'
    | 'app-generation' | 'feed-notification' | 'team-members'

export interface ConfigurationInstitution {
    name: string
    alias?: string | null
    logoUrl?: string | null
}

export interface ConfigurationHeaderProps {
    institution: ConfigurationInstitution
    activeTab: ConfigurationTabKey
    onBack: () => void
    onTabChange: (tab: ConfigurationTabKey) => void
}

const TABS: { key: ConfigurationTabKey; label: string }[] = [
    { key: 'profile', label: 'Institution Profile' },
    { key: 'branding', label: 'Branding' },
    { key: 'business-logic', label: 'Business Logic' },
    { key: 'app-generation', label: 'App Generation' },
    { key: 'feed-notification', label: 'Feed & Notification' },
    { key: 'team-members', label: 'Team Members' },
]

export const ConfigurationHeader: React.FC<ConfigurationHeaderProps> = ({
                                                                            institution, activeTab, onBack, onTabChange,
                                                                        }) => (
    <div className="configuration-header">
        <BackLink onClick={onBack} color="#667085">
            {institution.name}
        </BackLink>

        <Flex items="center" gap="1.2" topMargin="1.6">
            <Box
                width="4.4" height="4.4" radius="1"
                bgColor="#FEF6E7"
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}
            >
                {institution.logoUrl ? (
                    <img
                        src={institution.logoUrl}
                        alt={institution.name}
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                ) : (
                    <FiBriefcase size={20} color="#B54708" />
                )}
            </Box>
            <Box>
                <Text fontSize="2" style={fontBold} color={tokens.textDark}>
                    Configuration
                </Text>
                <Text fontSize="1.4" color={tokens.textMuted} topMargin="0.2">
                    {institution.alias || institution.name}
                </Text>
            </Box>
        </Flex>

        <div className="configuration-header__tabs">
            {TABS.map((tab) => (
                <button
                    key={tab.key}
                    type="button"
                    className={`configuration-header__tab ${
                        activeTab === tab.key ? 'configuration-header__tab--active' : ''
                    }`}
                    onClick={() => onTabChange(tab.key)}
                >
                    {tab.label}
                </button>
            ))}
        </div>
    </div>
)

export const buildConfigTabRoutes = (institutionId: string | number): Record<ConfigurationTabKey, string> => ({
    'profile': `/dashboardv2/institution-configuration?institutionId=${institutionId}&tab=profile`,
    'branding': `/dashboardv2/institution-configuration?institutionId=${institutionId}&tab=branding`,
    'business-logic': `/dashboardv2/institution-configuration?institutionId=${institutionId}&tab=business-logic`,
    'app-generation': `/dashboardv2/institution-configuration?institutionId=${institutionId}&tab=app-generation`,
    'feed-notification': `/dashboardv2/institution-configuration?institutionId=${institutionId}&tab=feed-notification`,
    'team-members': `/dashboardv2/institution-configuration?institutionId=${institutionId}&tab=team-members`,
})

export default ConfigurationHeader